import React from 'react';
import DataGrid, { Summary, GroupItem, TotalItem, ColumnFixing, Export, SortByGroupSummaryInfo, StateStoring } from 'devextreme-react/data-grid';
import { addCommasToNotional, firmSummaryDataColumns, skuSummaryDataColumns,
  dailySummaryDataColumns, venueSummaryDataColumns, venueRangeSummaryDataColumns, symbolSummaryDataColumns } from './columns.js';
import { TableHeader } from '../../components/TableHeader';
import { HeadTitle } from '../../components/HeadTitle';
import { Header } from '../../components/Header';
import { StatsHeader } from '../../components/StatsHeader';
import { SummaryFilter } from '../SummaryFilter';
import { getTotalSummary, getSkuSummary, getDailySummary, getSymbolSummary, getFirmSummary, getVenueSummary, getVenueRangeSummary } from '../../api/summary';
import { Loading } from '../../components/Loading';
import styles from './SummaryPage.module.scss';
import { numberWithCommas, roundNumber, formatDate } from '../../util/functions';

const addCommasToTotalData = (data) => {
  if (undefined !== data.value) {
    return numberWithCommas(data.value);
  }
  return 0;
};

const addCommasToNotionalData = (data) => {
  if (undefined !== data.value) {
    return numberWithCommas(roundNumber(data.value, 2));
  }
  return 0;
};

function geTradeSummaryStats (totalSummary, currentDateTime, tradeDate) {
  totalSummary = totalSummary || {};
  let summary =
    [
      {
        name: 'trade date',
        value: tradeDate ? formatDate(tradeDate, 'YYYY-MM-DD', 'MM/DD/YYYY') : '-'
      },
      {
        name: 'trades',
        value: totalSummary.trades ? numberWithCommas(totalSummary.trades) : '-'
      },
      {
        name: 'volume',
        value: totalSummary.volume ? numberWithCommas(totalSummary.volume) : '-'
      },
      {
        name: 'notional',
        value: totalSummary.notional ? numberWithCommas(totalSummary.notional) : '-'
      },
      {
        name: 'as of',
        value: currentDateTime || '-'
      }

    ];
  return summary;
}

var pagingOptions = {
  enabled: false
};

var loadingOptions = {
  enabled: false
};

class SummaryPage extends React.Component {
  constructor (props) {
    super(props);
    this.dataGridRef = React.createRef();
    this.state = {
      queryParam: {},
      title: 'ECN Trade Summary',
      summary: {
        error: null,
        isLoaded: false,
        data: []
      },
      downloadFileName: '',
      columns: skuSummaryDataColumns,
      isDownloadInactive: false,
      isSearching: false

    };
    this.baseState = this.state;

    this.loadData = this.loadData.bind(this);

    this.setQueryParameters = this.setQueryParameters.bind(this);
    this.handleEmptyOrErrorResults = this.handleEmptyOrErrorResults.bind(this);
    this.clear = this.clear.bind(this);
    this.download = this.download.bind(this);
    this.copyData = this.copyData.bind(this);
  }

  get dataGrid () {
    var gridRef;
    if (this.dataGridRef && this.dataGridRef.current) {
      gridRef = this.dataGridRef.current.instance;
    }
    return gridRef;
  }

  setQueryParameters (queryParamObj) {
    this.clear();
    // start the loading icon
    this.setState({ isSearching: true });
    // always send tradeTotalStats query
    this.getTotalTradeSummary(queryParamObj);
    this.setState({ queryParam: queryParamObj }, () => {
      this.loadData();
    });
  }

  loadData () {
    var filters = this.state.queryParam;
    //  console.log(filters);
    if (filters.summaryType) {
      if (filters.summaryType === 'sku') {
        this.getSkuTradeSummary(filters);
      } else if (filters.summaryType === 'venue') {
        this.getVenueTradeSummary(filters);
      } else if (filters.summaryType === 'symbol') {
        this.getSymbolTradeSummary(filters);
      } else if (filters.summaryType === 'firm') {
        this.getFirmTradeSummary(filters);
      } else if (filters.summaryType === 'daily') {
        this.getDailyTradeSummary(filters);
      } else if (filters.summaryType === 'venueRange') {
        this.getVenueRangeTradeSummary(filters);
      }
    }
  }

  getTotalTradeSummary (filters) {
    getTotalSummary(filters)
      .then(data => {
        //  console.log(data);

        if (undefined === data || data.length === 0) {
          console.log('No Total Trade Summary Data Found');
          this.setState({
            tradeTotalStats: geTradeSummaryStats(null, null, filters.date)
          });
        } else {
          this.setState({
            tradeTotalStats: geTradeSummaryStats(data.totalSummary, data.queryDateTime, data.tradeDate)
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          tradeTotalStats: geTradeSummaryStats(null, null, filters.date)
        });
      });
  }
  getSkuTradeSummary (filters) {
    getSkuSummary(filters)
      .then(data => {
        //  console.log(data);

        let results = data;

        if (undefined === results || results.length === 0) {
          this.handleEmptyOrErrorResults('No Data Found');
        } else {
          this.setState(prevState => ({
            summary: {
              ...prevState.summary,
              isLoaded: true,
              error: null,
              data: results
            },
            downloadFileName: `ECN_SKU_SUMMARY_${filters.date}`,
            columns: skuSummaryDataColumns
          }));
        }
      })
      .catch((error) => {
        // error
        console.log(error);
        var message = (error && error.response &&
          error.response.data && error.response.data) || 'Data currently unavailable';
        this.handleEmptyOrErrorResults(message);
      });
  }

  getVenueRangeTradeSummary (filters) {
    getVenueRangeSummary(filters)
      .then(data => {
        //  console.log(data);

        let results = data;

        if (undefined === results || results.length === 0) {
          this.handleEmptyOrErrorResults('No Data Found');
        } else {
          this.setState(prevState => ({
            summary: {
              ...prevState.summary,
              isLoaded: true,
              error: null,
              data: results
            },
            downloadFileName: `ECN_VENUE_RANGE_SUMMARY`,
            columns: venueRangeSummaryDataColumns
          }));
        }
      })
      .catch((error) => {
      // error
        console.log(error);
        var message = (error && error.response &&
        error.response.data && error.response.data) || 'Data currently unavailable';
        this.handleEmptyOrErrorResults(message);
      });
  }

  getVenueTradeSummary (filters) {
    getVenueSummary(filters)
      .then(data => {
        //  console.log(data);

        let results = data;

        if (undefined === results || results.length === 0) {
          this.handleEmptyOrErrorResults('No Data Found');
        } else {
          this.setState(prevState => ({
            summary: {
              ...prevState.summary,
              isLoaded: true,
              error: null,
              data: results
            },
            downloadFileName: `ECN_VENUE_SUMMARY_${filters.date}`,
            columns: venueSummaryDataColumns
          }));
        }
      })
      .catch((error) => {
      // error
        console.log(error);
        var message = (error && error.response &&
        error.response.data && error.response.data) || 'Data currently unavailable';
        this.handleEmptyOrErrorResults(message);
      });
  }

  getDailyTradeSummary (filters) {
    getDailySummary(filters)
      .then(data => {
        // console.log(data);

        let results = data;

        if (undefined === results || results.length === 0) {
          this.handleEmptyOrErrorResults('No Data Found');
        } else {
          this.setState(prevState => ({
            summary: {
              ...prevState.summary,
              isLoaded: true,
              error: null,
              data: results
            },
            downloadFileName: `ECN_DAILY_SUMMARY`,
            columns: dailySummaryDataColumns
          }));
        }
      })
      .catch((error) => {
      // error
        console.log(error);
        var message = (error && error.response &&
        error.response.data && error.response.data) || 'Data currently unavailable';
        this.handleEmptyOrErrorResults(message);
      });
  }

  getSymbolTradeSummary (filters) {
    getSymbolSummary(filters)
      .then(data => {
        //  console.log(data);

        let results = data;

        if (undefined === results || results.length === 0) {
          this.handleEmptyOrErrorResults('No Data Found');
        } else {
          this.setState(prevState => ({
            summary: {
              ...prevState.summary,
              isLoaded: true,
              error: null,
              data: results
            },
            downloadFileName: `ECN_SYMBOL_SUMMARY_${filters.date}`,
            columns: symbolSummaryDataColumns
          }));
        }
      })
      .catch((error) => {
        // error
        console.log(error);
        var message = (error && error.response &&
      error.response.data && error.response.data) || 'Data currently unavailable';
        this.handleEmptyOrErrorResults(message);
      });
  }

  getFirmTradeSummary (filters) {
    getFirmSummary(filters)
      .then(data => {
        //  console.log(data);

        let results = data;

        if (undefined === results || results.length === 0) {
          this.handleEmptyOrErrorResults('No Data Found');
        } else {
          this.setState(prevState => ({
            summary: {
              ...prevState.summary,
              isLoaded: true,
              error: null,
              data: results
            },
            downloadFileName: `ECN_FIRM_SUMMARY_${filters.date}`,
            columns: firmSummaryDataColumns
          }));
        }
      })
      .catch((error) => {
      // error
        console.log(error);
        var message = (error && error.response &&
    error.response.data && error.response.data) || 'Data currently unavailable';
        this.handleEmptyOrErrorResults(message);
      });
  }
  clear () {
  // just reset the data and not other config
    this.setState(this.baseState);
  }

  download () {
    if (this.state.isDownloadInactive) return;
    // make it inactive for future request until current one is solved
    this.setState({ isDownloadInactive: true });
    // download summary data
    if (this.dataGrid) {
      this.dataGrid.exportToExcel(false);
    }
    this.setState({ isDownloadInactive: false });
  }
  handleEmptyOrErrorResults (errorMessage) {
    this.setState(prevState => ({
      summary: {
        ...prevState.summary,
        isLoaded: true,
        data: [],
        error: errorMessage
      }
    }));
  }

  onSkuCellClick = (e) => {
    if (e.rowType === 'header' && e.column.allowSorting) {
      var existingSummaryItem = e.component.option('sortByGroupSummaryInfo[0]') && e.component.option('sortByGroupSummaryInfo[0]').summaryItem;
      var newSortField = e.column.dataField;
      if (existingSummaryItem === newSortField) {
        // just change the sort order
        e.component.option('sortByGroupSummaryInfo[0].sortOrder', e.component.option('sortByGroupSummaryInfo[0].sortOrder') === 'asc' ? 'desc' : 'asc');
      } else {
        e.component.option('sortByGroupSummaryInfo[0].summaryItem', newSortField);
        e.component.option('sortByGroupSummaryInfo[0].sortOrder', 'asc');
      }
    }
  }

  copyData () {
    var data = this.state.summary.data;
    if (data && data.length > 0) {
      var c, r, t;
      t = document.createElement('table');
      t.classList.add(styles.copyTable);
      t.id = 'venueCopyTable';
      // add header
      var header = t.createTHead();
      var headingRow = header.insertRow();

      c = headingRow.insertCell();
      c.appendChild(document.createTextNode('Venue'));
      c.classList.add(styles.copyDataHeader);

      c = headingRow.insertCell();
      c.appendChild(document.createTextNode('Trades'));
      c.classList.add(styles.copyDataHeader);

      c = headingRow.insertCell();
      c.appendChild(document.createTextNode('Volume'));
      c.classList.add(styles.copyDataHeader);

      c = headingRow.insertCell();
      c.appendChild(document.createTextNode('Notional'));
      c.classList.add(styles.copyDataHeader);

      header.appendChild(headingRow);
      t.appendChild(header);

      // add data
      var tData; var totalTrades = 0; var totalVolume = 0; var totalNotional = 0;
      let tbody = t.createTBody();
      data.forEach(function (item, index) {
        totalTrades += parseFloat(item.trades);
        totalVolume += parseFloat(item.volume);
        totalNotional += parseFloat(item.notional);
        r = tbody.insertRow();

        c = r.insertCell();
        c.appendChild(document.createTextNode(item.venue));
        c.classList.add(styles.copyTextData);

        c = r.insertCell();
        tData = numberWithCommas(item.trades);
        c.appendChild(document.createTextNode(tData));
        c.classList.add(styles.copyNumericData);

        c = r.insertCell();
        tData = numberWithCommas(item.volume);
        c.appendChild(document.createTextNode(tData));
        c.classList.add(styles.copyNumericData);

        c = r.insertCell();
        tData = numberWithCommas(item.notional);
        c.appendChild(document.createTextNode(tData));
        c.classList.add(styles.copyNumericData);
      });

      // add total row
      r = tbody.insertRow();
      c = r.insertCell();
      c.appendChild(document.createTextNode('Total'));
      c.classList.add(styles.copyTotalTextData);

      c = r.insertCell();
      tData = numberWithCommas(totalTrades);
      c.appendChild(document.createTextNode(tData));
      c.classList.add(styles.copyTotalNumericData);

      c = r.insertCell();
      tData = numberWithCommas(totalVolume);
      c.appendChild(document.createTextNode(tData));
      c.classList.add(styles.copyTotalNumericData);

      c = r.insertCell();
      tData = numberWithCommas(totalNotional);
      c.appendChild(document.createTextNode(tData));
      c.classList.add(styles.copyTotalNumericData);
    }

    document.body.appendChild(t);
    var copyText = t;
    var body = document.body; var range; var sel;
    if (document.createRange && window.getSelection) {
      range = document.createRange();
      sel = window.getSelection();
      sel.removeAllRanges();
      try {
        range.selectNodeContents(copyText);
        sel.addRange(range);
      } catch (e) {
        range.selectNode(copyText);
        sel.addRange(range);
      }
      document.execCommand('copy');
      sel.removeAllRanges();
    } else if (body.createTextRange) {
      range = body.createTextRange();
      range.moveToElementText(copyText);
      range.select();
      range.execCommand('Copy');
    }
    document.body.removeChild(t);
  }
  render () {
    // console.log(this.state);
    const isSkuSummary = this.state.queryParam.summaryType === 'sku';
    const isVenueSummary = this.state.queryParam.summaryType === 'venue';
    const isVenueRangeSummary = this.state.queryParam.summaryType === 'venueRange';
    const isSymbolSummary = this.state.queryParam.summaryType === 'symbol';
    const isFirmSummary = this.state.queryParam.summaryType === 'firm';
    const isDailySummary = this.state.queryParam.summaryType === 'daily';

    return (
      <div>
        <HeadTitle title={this.state.title} />
        <Header title={this.state.title} />
        {this.state.tradeTotalStats && <StatsHeader chartIcon stats={this.state.tradeTotalStats} topBorder />}

        <SummaryFilter search={this.setQueryParameters} clear={this.clear} />

        {this.state.isSearching && <Loading
          type='table'
          data={this.state.summary.data}
          loaded={this.state.summary.isLoaded}
          reloading={this.state.summary.isReloading}
          error={this.state.summary.error}
          emptyMessage='No results found.' ><div>
            { isSkuSummary && <div id='skuSummaryContent'>
              <TableHeader header={'Summary Data'} download={this.download} />
              <DataGrid ref={this.dataGridRef}
                dataSource={this.state.summary.data}
                defaultColumns={this.state.columns}
                onCellClick={this.onSkuCellClick}
                allowColumnReordering
                allowColumnResizing
                columnAutoWidth
                showColumnLines
                showRowLines
                hoverStateEnabled
                rowAlternationEnabled
                showBorders
                paging={pagingOptions}
                loadPanel={loadingOptions}
                cacheEnabled={false}
              >
                <Summary>
                  <GroupItem
                    column='sku'
                    summaryType='count'
                    displayFormat={' {0} SKU(s) '} />
                  <GroupItem
                    column='trades'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <GroupItem
                    column='volume'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <GroupItem
                    column='notional'
                    summaryType='sum'
                    customizeText={addCommasToNotionalData}
                    showInGroupFooter={false}
                    alignByColumn />
                </Summary>
                <SortByGroupSummaryInfo />
                <Export enabled fileName={this.state.downloadFileName} />

                <ColumnFixing enabled />
              </DataGrid> </div>}
            { isVenueRangeSummary && <div id='firmSummaryContent'>
              <TableHeader header={'Summary Data'} download={this.download} />
              <DataGrid ref={this.dataGridRef}
                dataSource={this.state.summary.data}
                defaultColumns={this.state.columns}
                allowColumnReordering
                allowColumnResizing
                columnAutoWidth
                showColumnLines
                showRowLines
                hoverStateEnabled
                rowAlternationEnabled
                showBorders
                paging={pagingOptions}
                loadPanel={loadingOptions}
                cacheEnabled={false}
              >
                <Summary>
                  <TotalItem
                    column='arcaTrades'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='arcaVolume'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='arcaNotional'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />

                  <TotalItem
                    column='cicfTrades'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='cicfVolume'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='cicfNotional'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />

                  <TotalItem
                    column='ecnTrades'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='ecnVolume'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='ecnNotional'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />

                  <TotalItem
                    column='idqsTrades'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='idqsVolume'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='idqsNotional'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />

                  <TotalItem
                    column='atsTrades'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='atsVolume'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='atsNotional'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />

                  <TotalItem
                    column='totalTrades'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='totalVolume'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='totalNotional'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />

                </Summary>
                <Export enabled fileName={this.state.downloadFileName} />
                <StateStoring enabled type='localStorage' storageKey='userVenueRangeSummaryColumns' savingTimeout={10} />

                <ColumnFixing enabled />

                <Export enabled fileName={this.state.downloadFileName} />
              </DataGrid>
            </div>
            }
            { isVenueSummary && <div id='venueSummaryContent'>
              <TableHeader header={'Summary Data'} download={this.download} copyToClipboardIconId='copyVenueTableIcon' onCopyToClipboardClick={this.copyData} />
              <DataGrid ref={this.dataGridRef}
                dataSource={this.state.summary.data}
                defaultColumns={this.state.columns}
                allowColumnReordering
                allowColumnResizing
                columnAutoWidth
                showColumnLines
                showRowLines
                hoverStateEnabled
                rowAlternationEnabled
                showBorders
                paging={pagingOptions}
                loadPanel={loadingOptions}
                cacheEnabled={false}
              >
                <Summary>
                  <TotalItem
                    column='trades'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='volume'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='notional'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                </Summary>
                <Export enabled fileName={this.state.downloadFileName} />
                <StateStoring enabled type='localStorage' storageKey='userVenueSummaryColumns' savingTimeout={10} />

                <ColumnFixing enabled />
              </DataGrid> </div>}
            { isSymbolSummary && <div id='symbolSummaryContent'>
              <TableHeader header={'Summary Data'} download={this.download} />
              <DataGrid ref={this.dataGridRef}
                dataSource={this.state.summary.data}
                defaultColumns={this.state.columns}
                allowColumnReordering
                allowColumnResizing
                columnAutoWidth
                showColumnLines
                showRowLines
                hoverStateEnabled
                rowAlternationEnabled
                showBorders
                paging={pagingOptions}
                loadPanel={loadingOptions}
                cacheEnabled={false}
              >
                <Summary>
                  <TotalItem
                    column='trades'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='volume'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='notional'
                    summaryType='sum'
                    customizeText={addCommasToNotional}
                    showInGroupFooter={false}
                    alignByColumn />
                </Summary>

                <StateStoring enabled type='localStorage' storageKey='userSymbolSummaryColumns' savingTimeout={10} />
                <Export enabled fileName={this.state.downloadFileName} />

                <ColumnFixing enabled />
              </DataGrid> </div>}

            { isDailySummary && <div id='dailySummaryContent'>
              <TableHeader header={'Summary Data'} download={this.download} />
              <DataGrid ref={this.dataGridRef}
                dataSource={this.state.summary.data}
                defaultColumns={this.state.columns}
                allowColumnReordering
                allowColumnResizing
                columnAutoWidth
                showColumnLines
                showRowLines
                hoverStateEnabled
                rowAlternationEnabled
                showBorders
                paging={pagingOptions}
                loadPanel={loadingOptions}
                cacheEnabled={false}
              >
                <Export enabled fileName={this.state.downloadFileName} />
              </DataGrid>
            </div>}
            { isFirmSummary && <div id='firmSummaryContent'>
              <TableHeader header={'Summary Data'} download={this.download} />
              <DataGrid ref={this.dataGridRef}
                dataSource={this.state.summary.data}
                defaultColumns={this.state.columns}
                allowColumnReordering
                allowColumnResizing
                columnAutoWidth
                showColumnLines
                showRowLines
                hoverStateEnabled
                rowAlternationEnabled
                showBorders
                paging={pagingOptions}
                loadPanel={loadingOptions}
                cacheEnabled={false}
              >
                <Summary>
                  <TotalItem
                    column='totalTrades'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='totalVolume'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='totalNotional'
                    summaryType='sum'
                    customizeText={addCommasToNotional}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='aboveTrades'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='aboveVolume'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='aboveNotional'
                    summaryType='sum'
                    customizeText={addCommasToNotional}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='betweenTrades'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='betweenVolume'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='betweenNotional'
                    summaryType='sum'
                    customizeText={addCommasToNotional}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='belowTrades'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='belowVolume'
                    summaryType='sum'
                    customizeText={addCommasToTotalData}
                    showInGroupFooter={false}
                    alignByColumn />
                  <TotalItem
                    column='belowNotional'
                    summaryType='sum'
                    customizeText={addCommasToNotional}
                    showInGroupFooter={false}
                    alignByColumn />
                </Summary>
                <StateStoring enabled type='localStorage' storageKey='userFirmSummaryColumns' savingTimeout={10} />
                <Export enabled fileName={this.state.downloadFileName} />

                <ColumnFixing enabled />
              </DataGrid> </div>}

          </div>
        </Loading>}
      </div>
    );
  }
}
export default SummaryPage;
